import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import Typography from '@mui/material/Typography';


const CostFrequencyField = ({ source = 'frequency', ...props }) => {
	const record = useRecordContext();
	const translate = useTranslate();

	if (!record) {
		return null;
	}

	const choices = {
		'oneoff': translate('One-off'),
		'monthly': translate('Monthly'),
		'quarterly': translate('Quarterly'),
		'yearly': translate('Yearly'),
		'biyearly': translate('Bi-yearly'),
		'weekly': translate('Weekly')
	};

	const value = record[source];

	if (!value) {
		return null;
	}

	return (
		<Typography variant="body2">{choices[value] || value}</Typography>
	);
};

export default CostFrequencyField;
